import React from "react";
import "./style.css";

const featuresData = [
  {
    id: 1,
    title: "الرؤية",
    text: "مجتمعات جذور بيئٌة آمنٌة وحافزٌة وداعمٌة لجميع أفرادها لعيش كريم جذوره العلم والعمل والتكافل المجتمعي",
    icon: "◉",
  },
  {
    id: 2,
    title: "الرسالة",
    text: "أن نساهم في تمكين أفراد وأسر المجتمعات المحلية السورية، اجتماعيا ونفسيا وتربويا وصحيا وتعليميا، بالتركيز على الفئات األكثر ضعفا وهشاشة، في بيئة مجتمعية داعمة وآمنة",
    icon: "✦",
  },
  {
    id: 3,
    title: "الغاية",
    text: "أن نساهم في تمكين أفراد وأسر المجتمعات المحلية السورية اجتماعيًا و نفسيًا وتربويًا وصحيًا وتعليميًا بالتركيز على الفئات األكثر ضعفًا وهشاشة في بيئة مجتمعية وداعمة",
    icon: "◆",
  },
  {
    id: 4,
    title: "القيم",
    text: "الشفافية - المصداقية - االمانة - الموضوعية وعدم التمييز - الحماية",
    icon: "◇",
  },
];

const Features = (props) => {
  return (
    <div id="features" className={`features-area features-luxury `} dir="rtl">
      <div className="container">
        <header className="features-luxury__header">
          <h2 className="features-luxury__heading">توجهات جذور</h2>
          <p className="features-luxury__subheading">
            مجتمعات جذور بيئٌة آمنٌة وحافزٌة وداعمٌة لجميع أفرادها لعيش كريم
            جذوره العلم والعمل والتكافل المجتمعي.
          </p>
        </header>
        <div className="features-luxury__row row">
          {featuresData.map((item) => (
            <div key={item.id} className="col-lg-3 col-md-6 col-12">
              <div className="features-luxury__card">
                <div className="features-luxury__icon">{item.icon}</div>
                <div className="features-luxury__content">
                  <h3 className="features-luxury__title">{item.title}</h3>
                  <p className="features-luxury__text">{item.text}</p>
                </div>
                <div className="features-luxury__accent" aria-hidden="true" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
